module.exports = __webpack_public_path__ + "static/digitalServices-2f4ef7206b63aaf8cb278a82632d39ca.png";